import { render, staticRenderFns } from "./pkgRiskReview.vue?vue&type=template&id=6d0302d7&"
import script from "./pkgRiskReview.vue?vue&type=script&lang=js&"
export * from "./pkgRiskReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports